import styled from "styled-components"
import { CircularProgress } from "@mui/material";

export const PrimaryCircularProgress = styled(CircularProgress)(({ theme }) => ({
    color: theme.palette.button.background.primary
  }));